import { PackageIcon } from '@phosphor-icons/react';
import { Button } from '@skupreme/shared/ui';
import { ReadOnlyTip, useOrdersV2 } from '../../hooks/orders-v2';

export type FulfillSelectionBarProps = {
  isSelecting: boolean;
  /** False when the page holds nothing that could be fulfilled. */
  canSelect: boolean;
  onStart: () => void;
  onCancel: () => void;
  selectedCount: number;
  onFulfill: () => void;
  isBusy?: boolean;
};

export function FulfillSelectionBar({
  isSelecting,
  canSelect,
  onStart,
  onCancel,
  selectedCount,
  onFulfill,
  isBusy,
}: FulfillSelectionBarProps) {
  const { isV2 } = useOrdersV2();

  if (!isSelecting) {
    /* Not on V2: fulfilling a selection is a legacy write. */
    return canSelect && !isV2 ? (
      <ReadOnlyTip>
        <Button variant="pill" size="md" isDisabled={isV2} onPress={onStart}>
          <PackageIcon size={12} weight="bold" />
          Fulfill orders
        </Button>
      </ReadOnlyTip>
    ) : null;
  }

  return (
    <div className="sk:inline-flex sk:items-center sk:gap-3 sk:rounded-full sk:bg-fill-tertiary sk:py-1 sk:pr-1 sk:pl-3">
      <span className="sk:text-xs sk:text-fg-secondary">
        {selectedCount === 0 ? (
          'Pick the orders to fulfill'
        ) : (
          <span className="sk:font-medium sk:text-fg">
            {selectedCount} selected
          </span>
        )}
      </span>

      <span className="sk:inline-flex sk:items-center sk:gap-1.5">
        <Button
          variant="primary"
          size="sm"
          isDisabled={selectedCount === 0 || isBusy}
          onPress={onFulfill}
        >
          {selectedCount > 1
            ? `Fulfill ${selectedCount} orders`
            : 'Fulfill order'}
        </Button>

        <Button
          variant="ghost"
          size="sm"
          onPress={onCancel}
          isDisabled={isBusy}
        >
          Cancel
        </Button>
      </span>
    </div>
  );
}
